/*** HOME Made By ES ***/
// @ts-nocheck

export const page = async () => {

    if(window.innerWidth <= 480){
        
        window.onload = () => {

            console.log("Working.....");
            document.querySelector('.game-section').style.height = "auto";
        };
    }
}